export default function usePaginationValuesWhere() {
  const setPaginationValuesWhere = (response, where, setWhere) => {
    setWhere({
      ...where,
      IndiceDePagina: parseInt(response.Pagina),
      CantidadPorPagina: parseInt(response.Tamano),
      PaginasTotal: parseInt(response.Total/response.Tamano) + 1,
      IsLoading: false,
    });
  };

  return {
    setPaginationValuesWhere,
  };
}
